import { Theme, createStyles } from '@material-ui/core/styles';

export const styles = (theme: Theme) => createStyles({
    root: {
        fontFamily: 'MuseoSans, sans-serif',
        marginBottom: '150px',
        marginTop: '237px',
        [theme.breakpoints.down(500)]: {
          marginBottom: '120px',
          marginTop: '190px',
        },
        [theme.breakpoints.down(400)]: {
          marginBottom: '100px',
          marginTop: '170px',
        },
    },
    content: {
        marginLeft: '28%',
        [theme.breakpoints.down(1200)]: {
          marginLeft: '23%',
        },
        [theme.breakpoints.down(1001)]: {
          marginLeft: '20%',
        },
        [theme.breakpoints.down(905)]: {
          marginLeft: '16%',
        },
        [theme.breakpoints.down(701)]: {
          marginLeft: '22%',
        },
        [theme.breakpoints.down(601)]: {
          marginLeft: '20%',
        },
        [theme.breakpoints.down(550)]: {
          marginLeft: '18%',
        },
    },
    titleContainer: {
        width: '100%',
        marginBottom: '4em',
        letterSpacing: '5.06px',
        textAlign: 'left',
        '& .title': {
            fontWeight: 900,
            fontSize: '90px',
            color: theme.palette.primary.main,
            letterSpacing: '7px',
            marginBottom: '0',
            textAlign: 'left',
        },
        '& #subtitle': {
            fontWeight: 500,
            fontSize: '35px',
            color: theme.palette.primary.main,
            letterSpacing: '1.34px',
            lineHeight: '51px',
            margin: '3em 0 0 0',
            width:'80%',
        },
        '& #snd': { marginLeft: '2em' },
        [theme.breakpoints.down(1085)]: {
          '& #subtitle': {
              width:'85%',
          },
        },
        [theme.breakpoints.down(1020)]: {
          '& #subtitle': {
              width:'90%',
          },
        },
        [theme.breakpoints.down(1001)]: {
          '& .title': {
              fontSize: '85px',
          },
          '& #subtitle': {
              fontSize: '30px',
              lineHeight: '45px',
              width:'80%',
          },
          '& #snd': { marginLeft: '1.5em' },
        },
        [theme.breakpoints.down(905)]: {
          '& #subtitle': {
            width:'86%',
          },
        },
        [theme.breakpoints.down(751)]: {
          '& #snd': { marginLeft: '1.2em' },
        },
        [theme.breakpoints.down(701)]: {
          '& .title': {
              fontSize: '75px',
          },
          '& #subtitle': {
              fontSize: '25px',
              lineHeight: '40px',
          },
          '& #snd': { marginLeft: '0em' },
        },
        [theme.breakpoints.down(601)]: {
          '& .title': {
              fontSize: '68px',
          },
          '& #subtitle': {
              fontSize: '23px',
              lineHeight: '35px',
          },
        },
        [theme.breakpoints.down(550)]: {
          '& .title': {
              fontSize: '60px',
          },
          '& #subtitle': {
              width:'95%',
          },
        },
        [theme.breakpoints.down(450)]: {
          '& .title': {
              fontSize: '47px',
          },
          '& #subtitle': {
              fontSize: '20px',
              lineHeight: '30px',
          },
        },
        [theme.breakpoints.down(400)]: {
          '& .title': {
              fontSize: '37px',
          },
          '& #subtitle': {
              fontSize: '16px',
              lineHeight: '25px',
          },
        },
    },
});
